<article [ngClass]="[needSaving ? 'not-saved' : 'saved', saving ? 'saving' : '']">
  <h2 class="heading-underline">
    <div class="back-button" (click)="router.navigate([DataToolsApps.DUPLIKIT_DASHBOARD])">
      <i class="bhi-previous"></i>
      <span>Back to Dashboard</span>
    </div>
    {{DataToolsAppsTitles.DUPLIKIT}} Options
    <span class="sub-info"><a  (click)="router.navigate([DataToolsApps.DUPLIKIT_DASHBOARD])"
                              [matTooltip]="'Return to ' + DataToolsAppsTitles.DUPLIKIT" matTooltipShowDelay="500">{{DataToolsAppsTitles.DUPLIKIT}}</a></span>
  </h2>
  <table class="table table-striped">
    <tbody>
    <tr>
      <td>Overnight Sync</td>
      <td>
        <mat-slide-toggle [(ngModel)]="options.nightlyRun" (change)="needsSaving()" [disabled]="isInLiteMode"></mat-slide-toggle>
      </td>
    </tr>
    <tr>
      <td>Dry Run</td>
      <td>
        <mat-slide-toggle [(ngModel)]="options.isDryRun" (change)="needsSaving()" [disabled]="isInLiteMode"></mat-slide-toggle>
      </td>
    </tr>
    <tr>
      <td>Notification Email</td>
      <td>
        <div>
          <input [(ngModel)]="options.notificationEmail" [disabled]="isInLiteMode"
                 placeholder="Email Notification" (keydown)="needsSaving()">
        </div>
      </td>
    </tr>
    <tr>
      <td>Maximum duplicates (scheduled and mass merges)
        <i class="bhi-info label-info"
           [matTooltip]="'If a master record has more than this number of duplicates, it will not be included in scheduled merges or in Merge Duplicates on the report page. Merging a single master is not affected.'"></i>
      </td>
      <td>
        <div>
          <input type="number" [(ngModel)]="options.maxDuplicatesPerMaster" [disabled]="isInLiteMode" placeholder="5"
                 (keydown)="dataToolsSettingsService.preventNonNumericValues($event)" (change)="needsSaving()"
                 min="1" inputmode="numeric" onpaste="return false">
        </div>
      </td>
    </tr>
    </tbody>
  </table>

  <!-- region Candidate -->
  <section class="minimisable" [ngClass]="{'minimise': toggleCandidatesOptions}">
    <h2 class="heading-underline" (click)="toggleCandidatesOptions = !toggleCandidatesOptions">Candidates Options</h2>
    <div class="plus-more" (click)="toggleCandidatesOptions = !toggleCandidatesOptions"><i class="bhi-sort-desc"></i>
    </div>
    <table class="table table-striped">
      <tbody>
      <tr *ngFor="let entity of ['Candidate']">
        <td>{{ entity }} Custom Query</td>
        <td>
          <div>
            <i class="bhi-info"
               [matTooltip]="entity + ' Custom Query can be enabled by Kyloe Support'"
               matTooltipPosition="left"
               *ngIf="!options.candidateCustomQueryEditable">
            </i>
            <input [(ngModel)]="options.candidateCustomQuery"
                   [disabled]="!options.candidateCustomQueryEditable || customQueryData[entity].validatingCustomQuery || isInLiteMode"
                   [ngClass]="[customQueryData[entity].recordsFound == 0 ? 'ng-invalid' : '', customQueryData[entity].recordsFound > 0 ? 'validQueryInput' : '']"
                   placeholder="{{ entity }} Custom query" (change)="queryChanged(entity)">
            <div class="customQueryValidation">
              <span> <i class="bhi-search" *ngIf="customQueryCanBeValidated(entity)" [matTooltip]="validateTooltip"
                        (click)="validateCustomQuery(entity, customQueryData[entity].defaultQuery + ' AND (' + getCustomQueryForEntity(entity) + ')')"></i> </span>
              <span *ngIf="customQueryData[entity].validatingCustomQuery"><i
                  class="validatingCustomQuery input-loading-spinner spinner-border spinner-border-sm"></i></span>
              <span *ngIf="customQueryData[entity].recordsFound == 0"><i
                  class="bhi-caution invalidCustomQuery" [matTooltip]="'0 records found.'"></i></span>
              <span *ngIf="customQueryData[entity].recordsFound > 0"><i
                  class="bhi-check validCustomQuery"
                  [matTooltip]="customQueryData[entity].recordsFound + ' records found.'"></i></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">{{ customQueryData.Candidate.defaultQuery }}
          <span class="label-custom-query" *ngIf="options.candidateCustomQuery"> AND ({{options.candidateCustomQuery}})</span>
        </td>
      </tr>
      <tr>
        <td>Merge skills and categories for candidates</td>
        <td>
          <mat-slide-toggle [disabled]="isInLiteMode" [(ngModel)]="options.mergeCandidateSkillsAndCategories" (change)="needsSaving()"></mat-slide-toggle>
        </td>
      </tr>
      <tr>
        <td>Merge specialties for candidates</td>
        <td>
          <mat-slide-toggle [disabled]="isInLiteMode" [(ngModel)]="options.mergeCandidateSpecialties" (change)="needsSaving()"></mat-slide-toggle>
        </td>
      </tr>
      <tr>
        <td>Candidate field-level merge</td>
        <td>
          <mat-slide-toggle [disabled]="isInLiteMode"
                       [(ngModel)]="options.fieldLevelMergeCandidate"
                       (change)="needsSaving()"></mat-slide-toggle>
        </td>
      </tr>
      <tr>
        <td>Candidate/contact tearsheet merge</td>
        <td>
          <mat-slide-toggle [disabled]="isInLiteMode"
                       [(ngModel)]="options.mergeTearsheets"
                       (change)="needsSaving()"></mat-slide-toggle>
        </td>
      </tr>
      <tr>
        <td>Candidate/contact custom object merge</td>
        <td>
          <mat-slide-toggle [disabled]="isInLiteMode"
                       [(ngModel)]="options.mergePersonCustomObjects"
                       (change)="needsSaving()"></mat-slide-toggle>
        </td>
      </tr>
      </tbody>
    </table>
  </section>
  <!-- endregion -->

  <!-- region ClientContact -->
  <section class="minimisable" [ngClass]="{'minimise': toggleContactOptions}">
    <h2 class="heading-underline" (click)="toggleContactOptions = !toggleContactOptions">Contacts Options</h2>
    <div class="plus-more" (click)="toggleContactOptions = !toggleContactOptions"><i class="bhi-sort-desc"></i></div>
    <table class="table table-striped">
      <tbody>
      <tr *ngFor="let entity of ['ClientContact']">
        <td>{{ entity }} Custom Query</td>
        <td>
          <div>
            <i class="bhi-info"
               [matTooltip]="entity + ' Custom Query can be enabled by Kyloe Support'"
               matTooltipPosition="left"
               *ngIf="!options.contactCustomQueryEditable">
            </i>
            <input [(ngModel)]="options.contactCustomQuery"
                   [disabled]="!options.contactCustomQueryEditable || customQueryData[entity].validatingCustomQuery || isInLiteMode"
                   [ngClass]="[customQueryData[entity].recordsFound == 0 ? 'ng-invalid' : '', customQueryData[entity].recordsFound > 0 ? 'validQueryInput' : '']"
                   placeholder="{{ entity }} Custom query" (change)="queryChanged(entity)">
            <div class="customQueryValidation">
              <span><i class="bhi-search" *ngIf="customQueryCanBeValidated(entity)" [matTooltip]="validateTooltip"
                        (click)="validateCustomQuery(entity, customQueryData[entity].defaultQuery + ' AND (' + getCustomQueryForEntity(entity) + ')')"></i> </span>
              <span *ngIf="customQueryData[entity].validatingCustomQuery"><i
                  class="validatingCustomQuery input-loading-spinner spinner-border spinner-border-sm"></i></span>
              <span *ngIf="customQueryData[entity].recordsFound == 0"><i
                  class="bhi-caution invalidCustomQuery" [matTooltip]="'0 records found.'"></i></span>
              <span *ngIf="customQueryData[entity].recordsFound > 0"><i
                  class="bhi-check validCustomQuery"
                  [matTooltip]="customQueryData[entity].recordsFound + ' records found.'"></i></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">{{ customQueryData.ClientContact.defaultQuery }}
          <span class="label-custom-query" *ngIf="options.contactCustomQuery"> AND ({{options.contactCustomQuery}})</span>
        </td>
      </tr>
      <tr>
        <td>Merge skills and categories for client contacts</td>
        <td>
          <mat-slide-toggle [disabled]="isInLiteMode" [(ngModel)]="options.mergeContactSkillsAndCategories" (change)="needsSaving()"></mat-slide-toggle>
        </td>
      </tr>
      <tr>
        <td>Merge specialties for client contacts</td>
        <td>
          <mat-slide-toggle [disabled]="isInLiteMode" [(ngModel)]="options.mergeClientContactSpecialties" (change)="needsSaving()"></mat-slide-toggle>
        </td>
      </tr>
      <tr>
        <td>Client Contact field-level merge</td>
        <td>
          <mat-slide-toggle [disabled]="isInLiteMode" [(ngModel)]="options.fieldLevelMergeContact" (change)="needsSaving()"></mat-slide-toggle>
        </td>
      </tr>
      <tr>
        <td>Candidate/contact tearsheet merge</td>
        <td>
          <mat-slide-toggle [disabled]="isInLiteMode" [(ngModel)]="options.mergeTearsheets" (change)="needsSaving()"></mat-slide-toggle>
        </td>
      </tr>
      <tr>
        <td>Candidate/contact custom object merge</td>
        <td>
          <mat-slide-toggle [disabled]="isInLiteMode" [(ngModel)]="options.mergePersonCustomObjects" (change)="needsSaving()"></mat-slide-toggle>
        </td>
      </tr>
      </tbody>
    </table>
  </section>
  <!-- endregion -->

  <!-- region ClientCorporation -->
  <section class="minimisable" [ngClass]="{'minimise': toggleCompaniesOptions}">
    <h2 class="heading-underline" (click)="toggleCompaniesOptions = !toggleCompaniesOptions">Companies Options</h2>
    <div class="plus-more" (click)="toggleCompaniesOptions = !toggleCompaniesOptions"><i class="bhi-sort-desc"></i>
    </div>
    <table class="table table-striped no-mar-b">
      <tbody>
      <tr *ngFor="let entity of ['ClientCorporation']">
        <td>{{ entity }} Custom Query</td>
        <td>
          <div>
            <i class="bhi-info"
               [matTooltip]="entity + ' Custom Query can be enabled by Kyloe Support'"
               matTooltipPosition="left"
               *ngIf="!options.companyCustomQueryEditable">
            </i>
            <input [(ngModel)]="options.companyCustomQuery"
                   [disabled]="!options.companyCustomQueryEditable || customQueryData[entity].validatingCustomQuery || isInLiteMode"
                   [ngClass]="[customQueryData[entity].recordsFound == 0 ? 'ng-invalid' : '', customQueryData[entity].recordsFound > 0 ? 'validQueryInput' : '']"
                   placeholder="{{ entity }} Custom query" (change)="queryChanged(entity)">
            <div class="customQueryValidation">
              <span> <i class="bhi-search" *ngIf="customQueryCanBeValidated(entity)" [matTooltip]="validateTooltip"
                        (click)="validateCustomQuery(entity, customQueryData[entity].defaultQuery + ' AND (' + getCustomQueryForEntity(entity) + ')')"></i> </span>
              <span *ngIf="customQueryData[entity].validatingCustomQuery"><i
                  class="validatingCustomQuery input-loading-spinner spinner-border spinner-border-sm"></i></span>
              <span *ngIf="customQueryData[entity].recordsFound == 0"><i
                  class="bhi-caution invalidCustomQuery" [matTooltip]="'0 records found.'"></i></span>
              <span *ngIf="customQueryData[entity].recordsFound > 0"><i
                  class="bhi-check validCustomQuery"
                  [matTooltip]="customQueryData[entity].recordsFound + ' records found.'"></i></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">{{ customQueryData.ClientCorporation.defaultQuery }}
          <span class="label-custom-query" *ngIf="options.companyCustomQuery"> AND ({{options.companyCustomQuery}})</span>
        </td>
      </tr>
      <tr>
        <td>Client Corporation field-level merge</td>
        <td>
          <mat-slide-toggle [disabled]="isInLiteMode" [(ngModel)]="options.fieldLevelMergeCompany" (change)="needsSaving()"></mat-slide-toggle>
        </td>
      </tr>
      <tr>
        <td>Client Corporation Locations merge</td>
        <td>
          <mat-slide-toggle [disabled]="isInLiteMode" [(ngModel)]="options.locationsMergeCompany" (change)="locationsMerge()"></mat-slide-toggle>
        </td>
      </tr>
      <tr>
        <td>Words to ignore from company names</td>
        <td>
          <div>
            <input [disabled]="isInLiteMode" [(ngModel)]="options.sanitisedWords" placeholder="limited, pty, llc" (keydown)="needsSaving()">
          </div>
        </td>
      </tr>
      <tr>
        <td>Worksite custom object</td>
        <td>
          <div>
            <input [disabled]="isInLiteMode" [(ngModel)]="options.worksiteObjectType" placeholder="" (keydown)="needsSaving()">
          </div>
        </td>
      </tr>
      <tr>
        <td>Worksite contact field</td>
        <td>
          <div>
            <input [disabled]="isInLiteMode" [(ngModel)]="options.worksiteContactField" placeholder="" (keydown)="needsSaving()">
          </div>
        </td>
      </tr>
      <tr>
        <td>Worksite job field</td>
        <td>
          <div>
            <input [disabled]="isInLiteMode" [(ngModel)]="options.worksiteJobField" placeholder="" (keydown)="needsSaving()">
          </div>
        </td>
      </tr>
      <tr>
        <td>Worksite placement field</td>
        <td>
          <div>
            <input [disabled]="isInLiteMode" [(ngModel)]="options.worksitePlacementField" placeholder="" (keydown)="needsSaving()">
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </section>
  <!-- endregion -->

  <section id="scheduledMergesOptions" class="minimisable"
           [ngClass]="{'minimise': toggleScheduledMerges}">
    <div (click)="toggleScheduledMerges = !toggleScheduledMerges; loadScheduledMerges = true">
      <h2 class="heading-underline">Schedule Merges</h2>
      <div class="plus-more"><i class="bhi-sort-desc"></i></div>
    </div>
    <app-scheduled-merges *ngIf="loadScheduledMerges" [canSchedule]="scheduledMergesEnabled">Save Options</app-scheduled-merges>
  </section>

  <section id="masterIdentificationOptions" class="minimisable no-mar-b"
           [ngClass]="{'minimise': toggleMasterIdentification}">
    <div (click)="toggleMasterIdentification = !toggleMasterIdentification; loadMasterIdentification = true">
      <h2 class="heading-underline">Master Identification</h2>
      <div class="plus-more"><i class="bhi-sort-desc"></i></div>
    </div>
    <app-master-identification-options *ngIf="loadMasterIdentification"></app-master-identification-options>
  </section>
</article>
